<div class="message">Ogiltig butik</div>

<style lang="scss">
	.message {
		text-align: center;
	}
</style>
